import type { CSSObject } from '@mantine/core';
import { createStyles } from '@mantine/core';
import { NODE_HEADER_HEIGHT, NODE_WIDTH } from '../constants';

interface IEntityNodeStylesProps {
	selected: boolean;
	isHighlighted: boolean;
	isSourceConnectable: boolean;
	isTargetConnectable: boolean;
	archived?: boolean;
	stale?: boolean;
}

export const useStyles = createStyles(
	(
		theme,
		{
			selected,
			isSourceConnectable,
			isTargetConnectable,
			archived,
			stale,
		}: IEntityNodeStylesProps
	) => {
		let sourceWidth = '0 !important';
		let sourceHeight = '0 !important';
		let sourceZIndex = 1;

		let targetWidth = '0 !important';
		let targetHeight = '0 !important';
		let targetZIndex = 1;

		if (isSourceConnectable) {
			sourceWidth = `${NODE_WIDTH}px !important`;
			sourceHeight = `${NODE_HEADER_HEIGHT}px !important`;
			sourceZIndex = 2;
		} else if (isTargetConnectable) {
			targetWidth = `${NODE_WIDTH}px !important`;
			targetHeight = `${NODE_HEADER_HEIGHT}px !important`;
			targetZIndex = 2;
		}

		// Determine node styling based on archived/stale status
		let nodeOpacity = 1;
		let nodeBorderColor = 'transparent';
		let nodeBackgroundColor = theme.other.getColor('surface/primary/default');

		if (stale) {
			// Archived entities: muted, grayed out appearance
			nodeOpacity = 0.8;
			nodeBorderColor = theme.other.getColor('border/secondary/default');
			nodeBackgroundColor = theme.other.getColor('surface/secondary/default');
		}
		if (archived) {
			// Stale entities: warning appearance with subtle alert styling
			nodeOpacity = 0.9;
			nodeBorderColor = theme.other.getColor('border/warning/default');
			nodeBackgroundColor = theme.other.getColor('surface/warning/default');
		}

		return {
			wrapper: {
				backgroundColor: nodeBackgroundColor,
				opacity: nodeOpacity,
				flexWrap: 'nowrap',
				justifyContent: 'space-between',
				width: NODE_WIDTH,
				height: 'fit-content',
				boxShadow: selected
					? `0px 0px 0px 2px ${theme.other.getColor('border/emphasis/default')}`
					: theme.shadows.sm,
				borderRadius: theme.radius.md,
				border: archived || stale ? `1px solid ${nodeBorderColor}` : 'none',
				overflow: 'hidden',
				gap: 0,
			},
			contentWrapper: {
				flexGrow: '1 !important' as CSSObject['flexGrow'],
				gap: 0,
			},
			handle: {
				width: '0 !important',
				height: '0 !important',
				backgroundColor: 'transparent !important',
				borderColor: 'transparent !important',
				top: `${NODE_HEADER_HEIGHT / 2}px !important`,
				borderRadius: '0 !important',
				'&:first-of-type': {
					width: targetWidth,
					height: targetHeight,
					zIndex: targetZIndex,
				},
				'&:last-of-type': {
					width: sourceWidth,
					height: sourceHeight,
					zIndex: sourceZIndex,
				},
			},
		};
	}
);
